"use strict";

// Definition of reinforcment steel types and its parameters
const steel = [
    {type: "B500B", fsd: 435, Es: 205}
];

// Variable initialisation
var cType = 1;  // Primary concrete type (ID)
var sType = 0;  // Primary steel type (ID)
var rX = 0;     // ID of Point plot...
var data = {mat: {}, geo: {}, cl: {}, plot: {}}; // Data Struct containing all informations about materials, geometry, calculations, plots
var init = 0; // Flag variable if all plots etc are initialised (1) or not (0)

//Global Variables
let M_Rd, l;

//Language
var url = window.location.href;
if(url.indexOf("/en/") !== -1) {
    var lang = "en";
} else {
    var lang = "de";
}

// Function if DropDown of Concrete Type get changed
$("#conType").change(function () {
    let Ec; // Youngs-Modulous concrete
    cType = parseInt($("#conType").val()); // Get chosen concrete type from DropDown
    // Write new values
    $("#conFctm").html(Mat.Concrete.types[cType].fctm);
    $("#conFcd").html(Mat.Concrete.types[cType].fcd);
    Ec = Math.round(Math.pow(Mat.Concrete.types[cType].fcm, (1 / 3)) * 10); // Calculate Youngs modulus
    $("#conEc").html(Ec);
    chgWertigkeit(); //Calculate new "Wertigkeit n"
});

// Function that calculates "Wertigkeit n" used if DropDown of Concrete or Reinforcment type changes
function chgWertigkeit() {
    // Calculate Wertigkeit and write it in DOM
    $("#n").html(Math.round(steel[sType].Es * 1000 / (Math.pow(Mat.Concrete.types[cType].fcm, (1 / 3)) * 100)) / 100);
}

// Carousel
$(document).ready(function () {
    $(".slkCarousel").slick({
        prevArrow: ".slick-prev",
        nextArrow: ".slick-next",
        appendDots: ".slkCarouselNav",
        dots: true,
    });
});

// Configuration for plotly
var config = pltConfig;

// Initialise Sliders

var xPositionSlider = document.getElementById('xposition');

noUiSlider.create(xPositionSlider, {
    start: [0],
    range: {
        'min': 0,
        'max': 10
    },
    tooltips: true,
    step: 0.1,
    pips: {
        mode: 'count',
        values: 11,
        density: 2
    },
    format: {
        to: function(value){
            return Math.round(value*10)/10;
        },
        from: function(value){
            return value;
        }
    }
});

let pipsLarge = 5;
let pipsSmall = 1;

if(window.checkMobile() == true){
    pipsLarge = 10;
    pipsSmall = 2;
}

var qSlider = document.getElementById('load');
function filterPips(value, type){
    if ( value % pipsLarge === 0){
        return 1;
    } else if( value% pipsSmall ==0 && value % pipsLarge != 0) {
        return 0;
    }
    else {
        return -1;
    }
}

noUiSlider.create(qSlider, {
    start: [15],
    range: {
        'min': 0,
        'max': 40.8

    },
    tooltips: true,
    step: 0.1,
    pips: {
        // mode: 'count',
        // values: 11,
        // density: 1
        mode: 'steps',
        filter: filterPips,
    },
    format: {
        to: function(value){
            return Math.round(value*10)/10;
        },
        from: function(value){
            return value;
        }
    }
});

// Adjust max Slider Value;
function adjustSlider(M_Rd,l){
    let max = Math.floor(8*M_Rd/(l*l)*10)/10;

    qSlider.noUiSlider.updateOptions({
        range: {
            min: 0,
            max: max,
        },
    });
}

// If anything with class="updCalc" get changed call function updateCalc()
$(".updCalc").change(function () {
    updateCalc();
    adjustSlider(convData(M_Rd,-6),l);
});

$(".iniCalc").change(function () {
    updateCalc();
    adjustSlider(convData(M_Rd,-6),l);
});

// Plot System
function plotSystem(l, xSection, x_r){
   //Initialisation of Variables
   let h, q;
   
   //Get values from Inputfields
   h= parseInt($("#conHeight").val())/1000;
   q = qSlider.noUiSlider.get();
   let offsetVariables = h/30;
   // Create Structure Plot
   let stPlt = new Group();

   // Plot Concrete Structure
   let cSt = new Group();
   cSt.addElm(new Rectangle(l, h, l/2, h/2).setFill(col.c_vis.getRgba()));
   if(x_r!=l/2){ 
        cSt.addElm(new Rectangle(x_r,h, x_r/2, h/2).setFill(col.base.getRgb()));
        cSt.addElm(new Rectangle(x_r,h, l-x_r/2, h/2).setFill(col.base.getRgb()));
   }
   else {
        cSt.addElm(new Rectangle(l, h, l/2, h/2).setFill(col.base.getRgb()));
   }
   
   cSt.addElm(new Support(0,0,1,0.150));
   cSt.addElm(new Support(l,0,2,0.150));

   cSt.addElm(new DimLine([0,-offsetVariables*2],[xSection,-offsetVariables*2],'x', 1/100, -offsetVariables*8, -4*offsetVariables)); 
   stPlt.addElm(cSt);

    // Plot Forces...
    let fGrp = new Group();
    if (q>0) {
        fGrp.addElm(new DistForce(0,h,l,h,q/100,0.1500));
    }
    stPlt.addElm(fGrp);


   // Plot Cut through section
   let lengthLine = 0.2;
   let gapToBeam = 0.05;
   let arrowLength = 0.2;
   stPlt.addElm(new Line([xSection,xSection],[-gapToBeam,-gapToBeam-lengthLine]).setColor(col.base.getRgb()));
   stPlt.addElm(new Line([xSection,xSection],[h+gapToBeam,h+gapToBeam+lengthLine]).setColor(col.base.getRgb()));

   let sectionLabel = 'I';
   if(xSection>x_r && xSection<l-x_r){
       sectionLabel = 'II';
   }
   
   if(xSection< l*0.75){
       stPlt.addElm(new Arrow(xSection+arrowLength,-gapToBeam-lengthLine,arrowLength,0,0.25).rotate(90,xSection+arrowLength,-gapToBeam-lengthLine)
            .setColor(col.base.getRgb()).setFill(col.base.getRgb()));
       stPlt.addElm(new Text(xSection+arrowLength+2*gapToBeam,-gapToBeam-lengthLine, sectionLabel ));
       stPlt.addElm(new Arrow(xSection+arrowLength,h+gapToBeam+lengthLine,arrowLength,0,0.25).rotate(90,xSection+arrowLength,h+gapToBeam+lengthLine)
            .setColor(col.base.getRgb()).setFill(col.base.getRgb()));
       stPlt.addElm(new Text(xSection+arrowLength+2*gapToBeam,h+gapToBeam+lengthLine, sectionLabel ));
   }
   else {
       stPlt.addElm(new Arrow(xSection-arrowLength,-gapToBeam-lengthLine,arrowLength,0,0.25).rotate(270,xSection-arrowLength,-gapToBeam-lengthLine)
            .setColor(col.base.getRgb()).setFill(col.base.getRgb()));
       stPlt.addElm(new Text(xSection-arrowLength-2*gapToBeam,-gapToBeam-lengthLine, sectionLabel ));
       stPlt.addElm(new Arrow(xSection-arrowLength,h+gapToBeam+lengthLine,arrowLength,0,0.25).rotate(270,xSection-arrowLength,h+gapToBeam+lengthLine,arrowLength)
            .setColor(col.base.getRgb()).setFill(col.base.getRgb()));
       stPlt.addElm(new Text(xSection-arrowLength-2*gapToBeam,h+gapToBeam+lengthLine, sectionLabel ));
   }

   let plt =stPlt.getPlotData();

   return plt;
}

// Plot "Schnittkräfte"
function plotSK(V, M,x, Mr,M_el, x_r, M_Rd, x_Rd, l, Av, Bv, xSection, pltSys){
    // Create Schnittkraft plot...
    let variableOffset = M_Rd/10;
    let mrtxt = "Moment, bei dem der Beton zu reissen beginnt. M<sub>r</sub> = ";
    let meltxt = "Moment, bei dem die elastische Betonspannung f<sub>cd</sub> erreicht. M<sub>el</sub> = ";
    let mrdtxt = "Biegewiderstand berechnet nach dem Traglastverfahren. M<sub>Rd</sub> = ";

    if(lang == "en") {
        mrtxt = "Moment when the concrete begins to crack. M<sub>r</sub> = ";
        meltxt = "Moment at which the elastic concrete stress reaches f<sub>cd</sub>. M<sub>el</sub> = ";
        mrdtxt = "Bending resistance calculated according to the load-bearing method. M<sub>Rd</sub> = ";
    }

    let pltData = {
        Data: [
            {
                x: V[0], //Convert from - to micro
                y: V[1], //Convert from N to kN
                mode: 'lines',
                fill: 'tozeroy',
                // xaxis: 'x2',
                yaxis: 'y2',
                line: {
                    width: 1,
                    color: 'rgb('+col.sk.getRgb()+')',
                },
                hoverinfo: 'none'
            },
            {
                x: x._data,
                y: M._data,
                mode: 'lines',
                fill: 'tozeroy',
                // xaxis: 'x3',
                yaxis: 'y3',
                line: {
                    width: 1,
                    color: 'rgb('+col.sk.getRgb()+')',
                },
                hoverinfo: 'none'
            },
            {
                x: [0,l],
                y: [Mr,Mr],
                mode: 'lines',
                yaxis: 'y3',
                line: {
                    width: 1,
                    color: 'rgb('+col.base.getRgb()+')',
                    dash: 'dash'
                },
                hoverinfo: 'none'
            },
            
            {
                x: [0,l],
                y: [M_Rd,M_Rd],
                mode: 'lines',
                yaxis: 'y3',
                line: {
                    width: 1,
                    color: 'rgb('+col.base.getRgb()+')',
                    dash: 'dash'
                },
                hoverinfo: 'none'
            },
            {
                x: [0,l],
                y: [M_el,M_el],
                mode: 'lines',
                yaxis: 'y3',
                line: {
                    width: 1,
                    color: 'rgb('+col.base.getRgb()+')',
                    dash: 'dash'
                },
                hoverinfo: 'none'
            },
            {
                x: [x_Rd, l-x_Rd],
                y: [M_Rd, M_Rd],
                mode: 'markers',
                yaxis: 'y3',
                color: 'rgb('+col.base.getRgb()+')',
                hoverinfo: 'none'
            },
            {
                x: [0.25],
                y: [Mr+variableOffset],
                mode: 'text',
                text: ['M<sub>r</sub>'],
                yaxis: 'y3',
                hovertemplate:
                mrtxt+Math.round(Mr)+"kNm",
                name: '',
            },
            {
                x: [0.75],
                y: [M_Rd-variableOffset],
                mode: 'text',
                text: ['M<sub>Rd</sub>'],
                yaxis: 'y3',
                hovertemplate:
                mrdtxt+Math.round(M_Rd)+"kNm",
                name: '',
            },
            {
                x: [ 0.5],
                y: [ M_el-variableOffset],
                mode: 'text',
                text: ['M<sub>el</sub>'],
                yaxis: 'y3',
                hovertemplate:
                meltxt+Math.round(M_el)+"kNm",
                name: '',
            },
            {
                x: [xSection, xSection],
                y: [-Av, Bv],
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(100,100,100)',
                    dash: 'dot'
                },
                yaxis: 'y2',
                hoverinfo: 'none'
            },
            {
                x: [xSection, xSection],
                y: [0, M_Rd],
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(100,100,100)',
                    dash: 'dot'
                },
                yaxis: 'y3',
                hoverinfo: 'none'
            }
        ],
        Layout: {
            hovermode: 'closest',
            hoverlabel: { bgcolor: "#FFF" },
            margin: {
                l: 60,
                r: 10,
                b: 50,
                t: 0,
                pad: 0
            },
            xaxis: {
                range: [-0.01*l, l*1.01],
                //showgrid: false,
                zeroline: false,
                // showline: false,
                // ticks: '',
                // showticklabels: false,
                title: 'x[m]'
            },
            yaxis: {
                scaleanchor: 'x',
                domain: [0.5, 1.0],
                showgrid: false,
                zeroline: false,
                showline: false,
                ticks: '',
                showticklabels: false,
            },
            yaxis2: {
                title: 'V [kN]',
                domain: [0.25, 0.5],
                range: [convData(-Av * 1.1, 0), convData(Bv * 1.1, 0)],
            },
            yaxis3: {
                title: 'M [kNm]',
                domain: [0.0, 0.25],
                range: [M_Rd*1.1,-M_Rd*0.2],
            },
            grid: {
                rows: 3,
                columns: 1,
            },
            showlegend: false
        },
    };

    pltSys.data.map((item) => {
        item.yaxis = 'y';
    });

    pltData.Data= pltData.Data.concat(pltSys.data);

    if(x_r!=l/2){
        let trace0 = {
            x: [x_r, l-x_r],
            y: [Mr, Mr],
            mode: 'markers',
            marker: {
                color: 'rgb(50,50,50)',
            },
            yaxis: 'y3',
            
        };
        pltData.Data= pltData.Data.concat(trace0);
    }

    if(window.checkMobile() == true){
        pltData.Layout.dragmode = false;
    }

    Plotly.react("plotSk", pltData.Data, pltData.Layout, config);

}

function plotEI(EI, Xi, x, l, xSection, pltSys){
    // Create EI and Xi plot...
    let pltData = {
        Data: [
            {
                x: x._data, //Convert from - to micro
                y: EI._data, //Convert from N to kN
                mode: 'lines',
                fill: 'tozeroy',
                yaxis: 'y2',
                line: {
                    width: 1,
                    color: 'rgb('+col.s.getRgb()+')',
                },
            },
            {
                x: x._data,
                y: convData(Xi._data,6),
                mode: 'lines',
                fill: 'tozeroy',
                yaxis: 'y3',
                line: {
                    width: 1,
                    color: 'rgb('+col.s.getRgb()+')',
                }
            },
            {
                x: [xSection, xSection],
                y: [0, math.max(EI._data)],
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(100,100,100)',
                    dash: 'dot'
                },
                yaxis: 'y2',
            },
            {
                x: [xSection, xSection],
                y: [0, convData(math.max(Xi._data),6)],
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(100,100,100)',
                    dash: 'dot'
                },
                yaxis: 'y3',
            }
        ],
        Layout: {
            hovermode: false,
            margin: {
                l: 60,
                r: 10,
                b: 50,
                t: 0,
                pad: 0
            },
            xaxis: {
                range: [-0.01*l, l*1.01],
                //showgrid: false,
                zeroline: false,
                // showline: false,
                // ticks: '',
                // showticklabels: false,
                title: 'x[m]'
            },
            yaxis: {
                scaleanchor: 'x',
                domain: [0.5, 1.0],
                showgrid: false,
                zeroline: false,
                showline: false,
                ticks: '',
                showticklabels: false,
            },
            yaxis2: {
                title: 'EI [MNm<sup>2</sup>]',
                range: [-50, math.max(EI._data) * 1.1],
                domain: [0.25, 0.5],
    
            },
            yaxis3: {
                title: 'Χ 10<sup>-9</sup> [m<sup>-1</sup>]',
                range: [0, convData(math.max(Xi) * 1.2, 6)],
                domain: [0.0, 0.25],
            },
            grid: {
                rows: 3,
                columns: 1,
            },
            showlegend: false
        },
    };

    pltSys.data.map((item) => {
        item.yaxis = 'y';
    });

    if(window.checkMobile() == true){
        pltData.Layout.dragmode = false;
    }

    pltData.Data= pltData.Data.concat(pltSys.data);
    Plotly.react("plotXi", pltData.Data, pltData.Layout, config);
}

function plotW(wStrich, w, x, l, xSection, pltSys){
    // Create EI and Xi plot...
    let pltData = {
        Data: [
            {
                x: x._data, //Convert from - to micro
                y: wStrich._data, //Convert from N to kN
                mode: 'lines',
                fill: 'tozeroy',
               // xaxis: 'x2',
                yaxis: 'y2',
                line: {
                    width: 1,
                    color: 'rgb('+col.def.getRgb()+')',
                },
            },
            {
                x: x._data,
                y: w._data,
                mode: 'lines',
                fill: 'tozeroy',
               // xaxis: 'x3',
                yaxis: 'y3',
                line: {
                    width: 1,
                    color: 'rgb('+col.def.getRgb()+')',
                }
            },
            {
                x: [xSection, xSection],
                y: [math.min(wStrich._data), math.max(wStrich._data)],
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(100,100,100)',
                    dash: 'dot'
                },
                //xaxis: 'x1',
                yaxis: 'y2',
            },
            {
                x: [xSection, xSection],
                y: [math.min(w._data), math.max(w._data)],
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(100,100,100)',
                    dash: 'dot'
                },
                //xaxis: 'x2',
                yaxis: 'y3',
            }
        ],
        Layout: {
            hovermode: false,
            margin: {
                l: 60,
                r: 10,
                b: 50,
                t: 0,
                pad: 0
            },
            xaxis: {
                range: [-0.01*l, l*1.01],
                //showgrid: false,
                zeroline: false,
                // showline: false,
                // ticks: '',
                // showticklabels: false,
                title: 'x[m]'
            },
            yaxis: {
                scaleanchor: 'x',
                domain: [0.5, 1.0],
                showgrid: false,
                zeroline: false,
                showline: false,
                ticks: '',
                showticklabels: false,
            },
            // xaxis: {
            //     rangemode: 'tozero',
            //     range: [0, convData(l, 0)],
            //     showticklabels: false
            // },
            yaxis2: {
                title: 'w´ [-]',
                range: [math.min(wStrich._data) * 1.5, math.max(wStrich._data) * 1.5],
                domain: [0.25, 0.5],
    
            },
            // xaxis2: {
            //     title: 'x [m]',
            //     rangemode: 'tozero',
            //     range: [0, convData(l, 0)],
            // },
            yaxis3: {
                title: 'w [mm]',
                range: [math.min(w._data) * 1.1, math.min(w._data) * -0.1],
                //autorange: true,
                domain: [0.0, 0.25],
            },
            grid: {
                rows: 3,
                columns: 1,
                //pattern: 'independent',
            },
            showlegend: false
        },
    };

    pltSys.data.map((item) => {
        item.yaxis = 'y';
    });

    if(window.checkMobile() == true){
        pltData.Layout.dragmode = false;
    }

    pltData.Data= pltData.Data.concat(pltSys.data);
    Plotly.react("plotW", pltData.Data, pltData.Layout, config);
}

function alertMinMax(htmlString, value, minValue, maxValue, textString, minString, maxString){
    let exceedMaxMin = false;
    let alertString;
    if(value < minValue){
        alertString = textString+' ist zu klein. Bitte wähle einen Wert zwischen '+minValue+' und '+maxValue+'.\n\n'+minString;
        if(lang == "en") {
            alertString = textString+' is too small. Please choose a value between '+minValue+' and '+maxValue+'.\n\n'+minString;
        }
        exceedMaxMin = true;
    }
    else if(value > maxValue){
        alertString = textString+' ist zu gross. Bitte wähle einen Wert zwischen '+minValue+' und '+maxValue+'.\n\n'+maxString;
        if(lang == "en") {
            alertString = textString+' is too big. Please choose a value between '+minValue+' and '+maxValue+'.\n\n'+minString;
        }
        exceedMaxMin = true; 
    }
    else if (isNaN(value)){
        alertString = 'Bitte eine Nummer eingeben.';
        if(lang == "en") {
            alertString = "Please insert a number";
        }
        exceedMaxMin = true;
    }

    if(exceedMaxMin){
        for(let i=0; i<htmlString.length;i++){
            document.getElementById(htmlString[i]).classList.add('is-invalid');
        }
        document.getElementById('Ctrl').classList.add('focus');
        alert(alertString);
        return exceedMaxMin;
    }else{
        for(let i=0; i<htmlString.length;i++){
            document.getElementById(htmlString[i]).classList.remove('is-invalid');
        }
        document.getElementById('Ctrl').classList.remove('focus');
    }
}

// Update Calculation
function updateCalc() {
    

    //Initialisation of Variables
    let h, b, q, V, M, Av, Bv, fctm, x_r, x_Rd, Ec, Es, As, d, n, rho, zc, I, x_0, EI_II, M_r, X_Rd, X, X_r, i, o, X_r2, X_y, i_r, x_eff, eps_c, fcd,
        eps_s, eps_cc, dx, scFac, scFacEps, scFacX,  xAxisInf, xAxisSup, limFc, iSy, iCRd, scX, w, wStrich, EI;

    //Set Variables
    l = 10;
    q = qSlider.noUiSlider.get();

    let xSection = xPositionSlider.noUiSlider.get();
    let exceedMaxMin = false;
    // Get values from input fields of As (Bewehrungsquerschnittsfläche), d (Statische Höhe), b (Breite) & h (Höhe)
    As = parseInt($("#refAs").val());
    d = parseInt($("#algD").val());
    b = parseInt($("#conWidth").val());
    h = parseInt($("#conHeight").val());
    fcd = Mat.Concrete.types[cType].fcd;
    fctm = Mat.Concrete.types[cType].fctm;

    let alertmsg = "Die Höhe h";
    if(lang == "en") {
        alertmsg = "The height h";
    }

    exceedMaxMin = alertMinMax(['conHeight'], h, 200, 800, alertmsg, '','');
    if(exceedMaxMin){
        return;
    }

    alertmsg = "Die Breite b";
    if(lang == "en") {
        alertmsg = "The width b";
    }
    exceedMaxMin = alertMinMax(['conWidth'], b, 200, 1000, alertmsg, '','');
    if(exceedMaxMin){
        return;
    }

    alertmsg = "Die statische Höhe d";
    if(lang == "en") {
        alertmsg = "The effective height d";
    }
    exceedMaxMin = alertMinMax(['algD','conHeight'], d, h/2, h-20, alertmsg, '','');
    if(exceedMaxMin){
        return;
    }
    let AsMax = Math.round(0.85*0.5*d*b*fcd/steel[sType].fsd/10)*10;
    let AsMin = Math.round((d*b*fcd/steel[sType].fsd*(1-Math.sqrt(1-Math.pow(h,2)*fctm/(3*Math.pow(d,2)*fcd))))/10)*10;
    if(lang == "en") {
        exceedMaxMin = alertMinMax(['refAs'], As, AsMin, AsMax, 'The reinforcement content',
        'Brittle failure in case of cracking!\nThe cracking moment is greater than the bending resistance.\n\nNot enough reinforcement available (keyword: minimum reinforcement).',
        'The reinforcement content is limited to x/d=0.5 (see swiss-code SIA 262 4.1.4.2).'); // Choosing a value between 0 and rho_s=3%
    } else {
        exceedMaxMin = alertMinMax(['refAs'], As, AsMin, AsMax, 'Der Bewehrungsgehalt',
        'Sprödes Versagen bei Rissbildung!\nDas Rissmoment ist grösser als der Biegewiderstand.\n\nNicht genügend Bewehrung vorhanden (Stichwort: Mindestbewehrung).',
        'Der Bewehrungsgehalt ist auf x/d=0.5 beschränkt (siehe SIA 262 4.1.4.2).'); // Choosing a value between 0 and rho_s=3%
    }
    
    if(exceedMaxMin){
        return;
    }


    // Calculate Supportforces
    Av = (q*l)/2;
    Bv = Av;

    Ec = Math.pow(Mat.Concrete.types[cType].fcm, (1 / 3)) * 10000; // Calculate Youngs-Modulous of concrete
    Es = steel[sType].Es * 1000; // Get Youngs-Modulous of reinforcment into Es
    //let fsd = steel[sType].fsd;

 
    n = Es / Ec; // Calc "Wertigkeit"
    rho = As / (d * b); // Calc "Bewehrungsgehalt"

    zc = ((b * Math.pow(h, 2)) / 2 + As * d * (n - 1)) / (b * h + As * (n - 1)); // Calc "Schwerpunkt (n-Verfahren)"
    I = (b * Math.pow(h, 3)) / 12 + Math.pow((h / 2 - zc), 2) * b * h + As * (n-1) * Math.pow((d - zc), 2); // Calc "Flächenträgheitsmoment"

    x_0 = d * (Math.sqrt(Math.pow((n * rho), 2) + 2 * rho * n) - rho * n); // Calc "Druckzonenhöhe Zustand II - gerissen-elast"
    EI_II = As * Es * (d - x_0) * (d - x_0 / 3); // EI_II gerissen elast


    
    M_r = fctm*I/(h-zc);   //Rissmoment (ohne 1.3)
    //M_Rd =  As * steel[sType].fsd * (d - x_0/3); // Widerstandmoment berechnet mit der Annahme von einem rein elastischem Betonverhalten. 
    M_Rd = As * steel[sType].fsd * (d - As * steel[sType].fsd / (2 *0.85* b * Mat.Concrete.types[cType].fcd));

    // console.log(M_Rd, M_r);

    // M_Rd = As * steel[sType].fsd * (d - As * steel[sType].fsd / (2 * b * Mat.Concrete.types[cType].fcd)); // Widerstandmoment

    // Schnittkräfte berechnen
    V = [[0, 0, l, l], [0, -Av, Bv, 0]];
    var x = math.range(0, l + l / 1000, l / 1000); //Abstandsvektor
    M = math.zeros(x._data.length); //Fill up moment vector with zeros


    for (let o = 0; o < x._data.length - 1; o++) {
        M._data[o] =  Av * x._data[o]- q*x._data[o]*x._data[o]/2 ;
        if (o > 1){
            if(M._data[o]> convData(M_r,-6) && M._data[o-1]< convData(M_r,-6)){
                x_r = x._data[o];
            }
            
            if(M._data[o]< convData(M_Rd,-6) && M._data[o-1]> convData(M_Rd,-6)){
                x_Rd = x._data[o];
            }
        }
    }
    if(math.max(M._data)< convData(M_r,-6) ){
        x_r = l/2
    }
    
    //console.log(math.min(M));
    if (math.max(M)>convData(M_Rd,-6)){
        //qSlider.noUiSlider.set([Math.floor(8*M_Rd/(l*l)*10)/10])
        if(lang == "en") {
            alert('The applied load cannot be supported with the current configuration.');
        } else {
            alert('Mit der derzeitigen Konfiguration kann die aufgebrachte Last nicht getragen werden.');
        }
    }

    // Moment where the elastic stresses of the concrete reach fcd
    
    let M_el = b*fcd*x_0/2*(d-x_0/3);
    //console.log("M_el: "+M_el);

    //x = math.range(0, l + l / 1000, l / 1000); //Abstandsvektor
    EI = math.zeros(x._data.length); //Fill up EI plot vector with zeros
    X = math.zeros(x._data.length); //Fill up EI plot vector with zeros
    wStrich = math.zeros(x._data.length); //Fill up w' plot vector with zeros
    w = math.zeros(x._data.length); //Fill up w plot vector with zeros
    x_eff = math.zeros(x._data.length); // Array für Druckzonenhöhe.

    let nSteps = x._data.length;

    // // Berechnung der Druckzonenhöhen...
    // x_eff = math.multiply(math.ones(X._data.length), x_0); // Vector of "Druckzonenhöhen"
    // x_eff._data.fill(zc, 0, i_r - 1); //Array (Vector) füllen mit Druckzonenhöhe (Schwerpunkt) zc bis zum Reissen

    for (o = 0; o < x._data.length - 1; o++) {
        if(x._data[o]> x_r && x._data[o]<l-x_r){
            EI._data[o] = convData(EI_II,-12);
            X._data[o] = convData(M._data[o],6)/(EI_II);
            x_eff._data[o]= x_0;
            //console.log('Gerissen: '+X._data[o] );
        }
        else {
            EI._data[o] = convData(Ec*I,-12);
            X._data[o]  = convData(M._data[o],6)/(Ec*I);
            x_eff._data[o] = zc;
            
        }
        
       // w._data[o] = -l*q*math.pow(x._data[o],3)/(12*EI._data[o])+q*math.pow(x._data[o],4)/(24*EI._data[o])+math.pow(l,3)*q*x._data[o]/(24*EI._data[o]);
    }

    //console.log(nSteps);
    //console.log('Chi[0]: '+X._data[1]*1000*l/nSteps);

    for(o=0; o<nSteps;o++){
        //console.log(X._data[o]);
        //console.log(wStrich._data[o]);
        if (o==0){
            //console.log('here')
            wStrich._data[o] = l*1000/nSteps*X._data[o];
        }
        else {
            wStrich._data[o] = wStrich._data[o-1]+l*1000/nSteps*X._data[o];
        }
        //console.log('wStrich: '+wStrich._data[o]);
    }

    let offsetWStrich = wStrich._data[Math.round(nSteps/2)-1];

    for(o=0; o<nSteps;o++){
        wStrich._data[o] = wStrich._data[o]-offsetWStrich;
        if (o==0){
            //console.log('here')
            w._data[o] = l*1000/nSteps*wStrich._data[o];
        }
        else {
            w._data[o] = w._data[o-1]+l*1000/nSteps*wStrich._data[o];
        }
    }

    // Build plotData for the statical System
    let pltSys = plotSystem(l, xSection, x_r);

    plotSK(V,M,x,convData(M_r,-6),convData(M_el,-6), x_r,convData(M_Rd,-6), x_Rd, l, Av, Bv, xSection, pltSys);

    plotEI(EI,X,x,l, xSection, pltSys);

    plotW(wStrich, w, x, l, xSection, pltSys);


    rX = math.round(xPositionSlider.noUiSlider.get()/l*x._data.length);
    
    // Neuer Vektor dx_eff mit Differenz aus statischer Höhe und Druckzonenhöhe (Hebelarm Bewehrung)
    let dx_eff = math.map(x_eff, function (value) {
        return d - value;
    });

    // Dehnungen am Rand (Beton) und Bewehrung rechnen...
    eps_c = math.dotMultiply(X, x_eff);
    eps_s = math.dotMultiply(X, dx_eff);

    //i = rX; //Math.max(1, rX);
    
    eps_cc = eps_c._data[rX] / x_eff._data[rX] * (h - x_eff._data[rX]); //Dehnung am unteren Rand (gültig aufgrund Ebenbleiben QS)

    // Calulate offset for stress plot
    dx = 90; // Standard offset...
    //dx = eps_c._data[eps_c._data.length - 1] / x_eff._data[x_eff._data.length - 1] * (h - x_eff._data[x_eff._data.length - 1]) * 10000 + dx;
    scFac = 5; // Scale Factor...
    scFacEps = 10000;
    scFacX = 1;
    scX = $("#scXAxis").prop("checked");

    xAxisInf = -math.max(eps_c._data) * scFacEps-20; // Lower limit of xAxis
    xAxisSup = Math.max((steel[sType].fsd / scFac), (eps_c._data[eps_c._data.length - 1] * Ec)) + dx; // Upper limit of xAxis

    if (eps_s._data[rX]*Es < steel[sType].fsd/scFac && scX){
        // Scale x-Axis till sig_s > fsd/scFac
        scFacX = 10;
    }

    // Update values...
    $('#x').html(Math.round(x_eff._data[rX]));
    $('#mom').html(Math.round(M._data[rX]));
    $('#chi').html(Math.round(convData(X._data[rX],7))/10+' · 10<sup>-6</sup>');
    $('#w').html(Math.round(-w._data[rX]));
    $('#ei_i').html(Math.round(Ec*I/Math.pow(10,10))+' · 10<sup>10</sup>');
    $('#ei_ii').html(Math.round(EI_II/Math.pow(10,10))+' · 10<sup>10</sup>');


    // Calculate vectors for stress and strain plots...
    let nAxis = { //Neutral axis...
        x: [xAxisInf, xAxisSup],
        y: [h - x_eff._data[rX], h - x_eff._data[rX]]
    };

    let eps = {
        QS: { // Strain values for cross section
            x: [0, -eps_c._data[rX] * scFacEps * scFacX, eps_cc * scFacEps * scFacX, 0],
            y: [h, h, 0, 0]
        },
        s: { // Strain values for reinforcement
            x: [0, eps_s._data[rX]*scFacEps * scFacX],
            y: [h-d, h-d]
        }
    };

    $('#epsCSup').html(Math.round(eps_c._data[rX]*100000)/100);
    $('#epsCInf').html(Math.round(eps_cc*100000)/100);
    $('#epsS').html(Math.round(eps_s._data[rX]*100000)/100);

    let sig = {s:{},c:{}};
    if (eps_cc < Mat.Concrete.types[cType].fctm/Ec){
        // Vor dem Reissen
        sig = {
            s: { // Stress values for reinforcement
                x: [dx, (eps_s._data[rX]*Es/scFac)*scFacX+dx],
                y: [h-d, h-d]
            },
            c: {
                x: [dx, eps_c._data[rX]*Ec*scFacX+dx, dx, eps_cc*Ec*scFacX+dx, dx],
                y: [h, h, h-x_eff._data[rX], 0, 0]
            }
        };
        $('#sigCSup').html(-Math.round(eps_c._data[rX]*Ec*10)/10);
        $('#sigCInf').html(Math.round(eps_cc*Ec*10)/10);
        $('#sigS').html(Math.round(eps_s._data[rX]*Es));
    }else{
        // Nach dem Reissen
        if (!limFc || (eps_c._data[rX] < Mat.Concrete.types[cType].fcd/Ec)) {
            sig.c = {
                x: [dx, eps_c._data[rX]*Ec*scFacX+dx, dx],
                y: [h, h, h-x_eff._data[rX]]
            };
            $('#sigCSup').html(-Math.round(eps_c._data[rX]*Ec*10)/10);
            $('#sigCInf').html(0);

        }else{
            sig.c = {
                x: [dx, Mat.Concrete.types[cType].fcd*scFacX+dx, Mat.Concrete.types[cType].fcd*scFacX+dx, dx],
                y: [h, h, h-(x_eff._data[rX]-Mat.Concrete.types[cType].fcd/(X._data[rX]*Ec)), h-x_eff._data[rX]]
            };
            $('#sigCSup').html(-Math.round(Mat.Concrete.types[cType].fcd*10)/10);
            $('#sigCInf').html(0);
        }

        sig.s = {
            x: [dx, math.min([eps_s._data[rX] * Es, steel[sType].fsd]) / scFac * scFacX + dx],
            y: [h - d, h - d]
        };
        $('#sigS').html(Math.round(math.min([eps_s._data[rX] * Es, steel[sType].fsd])));
    }

    let titlePlot = 'Dehnungen & Spannungen im Schnitt I-I (ungerissen)';
    if(lang == "en") {
        titlePlot = 'Strains and stresses in section I-I (uncracked)';
    }
    if(xSection>x_r && xSection<l-x_r){
        if(lang == "en") {
            titlePlot = 'Strains and stresses in section II-II (cracked)';
        } else {
            titlePlot = 'Dehnungen & Spannungen im Schnitt II-II (gerissen)';
        }
    }
    $('#titleStressStrain').html(titlePlot);

    let offsetVariables = h/30;

    // Create new plot...
    data.plot.QS = {
        Data: [
            {   // 0: Dehnungsebene
                x: [0, 0],
                y: [0, h],
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(50, 50, 50)',
                }
            },
            {   // 1: Spannungsebene
                x: [dx-5,dx,dx,dx-5],
                y: [0,0,h,h],
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(50, 50, 50)',
                },
                fill: 'toself',
                fillcolor: 'rgba(50,50,50,0.1)',
            },
            {   // 2: Neutralachse (grau, gestrichelt)
                x: nAxis.x,
                y: nAxis.y,
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(100, 100, 100)',
                    dash: 'dashdot',
                }
            },
            {   // 3: Dehnungen (QS, orange)
                x: eps.QS.x,
                y: eps.QS.y,
                mode: 'lines',
                
                line: {
                    width: 1,
                    color: 'rgb(224, 82, 0)',
                }
            },
            {   // 4: Dehnungen (Bewehrung, blau)
                x: eps.s.x,
                y: eps.s.y,
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(10, 63, 145)',
                }
            },
            {   // 5: Betonspannungen (Grün)
                x: sig.c.x,
                y: sig.c.y,
                mode: 'lines',
                fill: 'tonext',
                line: {
                    width: 1,
                    color: 'rgb(10, 145, 12)',

                }
            },
            {   // 6: Stahlspannungen (Blau)
                x: sig.s.x,
                y: sig.s.y,
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(10, 63, 145)',
                }
            },
            {   // 7: fcd (grau, dotted)
                x: [Mat.Concrete.types[cType].fcd*scFacX+dx, Mat.Concrete.types[cType].fcd*scFacX+dx],
                y: [h, 2*h/3],
                mode: 'lines',
                line: {
                    width: 1,
                    color: 'rgb(150, 150, 150)',
                    dash: 'dot',
                }
            },
            {   // Beschriftung
                x: [eps.QS.x[1], eps.QS.x[2], eps.s.x[1]+offsetVariables/10, 
                    sig.c.x[1], sig.c.x[2], sig.s.x[1]],
                y: [eps.QS.y[1]+offsetVariables, eps.QS.y[2]-offsetVariables, eps.s.y[1]+offsetVariables, 
                    sig.c.y[1]+offsetVariables, -offsetVariables, sig.s.y[1]+offsetVariables],
                mode: 'text',
                text: ['ε<i><sub>sup</sub></i>', 'ε<i><sub>inf</sub></i>','ε<i><sub>s</sub></i>',
                    'σ<i><sub>sup</sub></i>', 'σ<i><sub>inf</sub></i>',  'σ<i><sub>s</sub></i>' ],
            },
        ],
        Layout: {
            hovermode: false,
            height: 350,
            margin: {
                l: 60,
                r: 0,
                b: 40,
                t: 30,
                pad: 0
            },
            xaxis: {
                visible: false,
                range: [xAxisInf, xAxisSup],
            },
            yaxis: {
                visible: false,
                range: [-offsetVariables*2, h+offsetVariables*2],
            },
            showlegend: false,
            annotations: [{
                yref: 'paper',
                x: 0,
                xanchor: 'middle',
                y: 0,
                yanchor: 'top',
                text: 'ε',
                showarrow: false
            },{
                yref: 'paper',
                x: dx,
                xanchor: 'middle',
                y: 0,
                yanchor: 'top',
                text: 'σ',
                showarrow: false
            },{
                x: Mat.Concrete.types[cType].fcd*scFacX+dx,
                xanchor: 'left',
                y: 2*h/3,
                yanchor: 'top',
                text: 'f<sub>cd</sub>',
                showarrow: false
            }],
        },
    };

    if(xSection<x_r || xSection>l-x_r){
        if(xSection!=0){
            let traceSign = {
                x: [dx+5, dx+5],
                y: [h*0.05, h*0.95],
                mode: 'text',
                text: ['⊕','⊖'],
            };
            data.plot.QS.Data= data.plot.QS.Data.concat(traceSign);
        }
    }

    if(window.checkMobile() == true){
        data.plot.QS.Layout.dragmode = false;
    }
    Plotly.react("plotQS", data.plot.QS.Data, data.plot.QS.Layout, pltConfig);
}

function updatePosition(values, handle, unencoded, tap, positions) {
   updateCalc();
}

function updateLoad(values){
    updateCalc();
}

updateCalc();

// xPositionSlider.noUiSlider.on('change', updatePosition);
// qSlider.noUiSlider.on('change', updateLoad);

if(window.checkMobile() == true){
    xPositionSlider.noUiSlider.on('change', updatePosition);
    qSlider.noUiSlider.on('change', updateLoad);
}
else {
    xPositionSlider.noUiSlider.on('slide', updatePosition);
    qSlider.noUiSlider.on('slide', updateLoad);; 
}

//Converting function

function convData(data, pow){
    if(typeof data === 'object') {
        if (Array.isArray(data)) {
            return data.map(function (value) {
                return value * Math.pow(10, pow);
            });
        } else {
            return math.map(data, function (value) {
                return value * Math.pow(10, pow);
            });
        }
    }else{
        return data*Math.pow(10,pow);
    }
}